import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
// #fake-start#
import { FakeAPIService } from './_fake/fake-api.service';
import { AuthService } from './core/services/auth.service';
import { SweetAlertService } from './core/services/sweet-alert.service';
import { MessageService } from 'primeng/api';
import { AuthGuard } from './core/security/auth.guard';
import { AntiAuthGuard } from './core/security/anti-auth.guard';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { NullInterceptor } from './core/interceptors/null-interceptor';
import { SimulasyonBannerComponent } from './core/components/simulasyon-banner/simulasyon-banner.component';
import { AuthInterceptor } from './core/interceptors/auth-interceptor';
import { UYGULAMA_LOCALE } from './core/config/tarih.config';

// #fake-end#

// Angular'ın `| date` pipe'ı LOCALE_ID'ye karşılık gelen locale verisi kayıtlı
// değilse en-US'e düşer ve tarihleri İngilizce basar. Kayıt uygulama başlarken
// bir kez yapılır; ayrıntı için core/config/tarih.config.ts.
registerLocaleData(localeTr);

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      //@ts-ignore
      // authService.getUserByToken().subscribe().add(resolve);
      authService.GetUserFromLocalStorage().subscribe().add(resolve);
    });

  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    ClipboardModule,
    SweetAlert2Module,
    NgSelectModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),

    // #fake-start#
    environment.isMockEnabled
      ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
        passThruUnknownUrl: true,
        dataEncapsulation: false,
      })
      : [],
    // #fake-end#
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    // SweetAlert2Module.forRoot(),
    ToastModule,
    RippleModule,
    SimulasyonBannerComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    { provide: LOCALE_ID, useValue: UYGULAMA_LOCALE },
    SweetAlertService,
    MessageService,
    AuthGuard,
    AntiAuthGuard,
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: NullInterceptor, 
      multi: true 
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // Burada interceptor ekleniyor
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
